import { useCheckBulkPermissions } from "@/api/relations";
import { useContext } from "react";

import { CanvasRouteContext } from "../context/CanvasRouteContext";

/**
 * Bulk permission checks for the current canvas (`can_edit`, `can_manage_assignments`, etc.).
 *
 * By default reads `canvasId` from `CanvasRouteProvider`. Pass `canvasId` when the hook runs
 * outside that provider (e.g. `CanvasExplorerPane` in the app layout shell).
 */
export function useCanvasPermissions(canvasIdOverride?: string) {
  const routeCtx = useContext(CanvasRouteContext);
  const canvasId = canvasIdOverride ?? routeCtx?.canvasId;
  const { data: permissions } = useCheckBulkPermissions({
    checks: canvasId
      ? [
          {
            resource_object_type: "canvas",
            resource_object_id: canvasId,
            permission: "can_view",
          },
          {
            resource_object_type: "canvas",
            resource_object_id: canvasId,
            permission: "can_edit",
          },
          {
            resource_object_type: "canvas",
            resource_object_id: canvasId,
            permission: "can_delete",
          },
          {
            resource_object_type: "canvas",
            resource_object_id: canvasId,
            permission: "can_manage_assignments",
          },
        ]
      : [],
  });

  const canEdit = canvasId
    ? (permissions?.canvas?.[canvasId]?.can_edit ?? false)
    : false;
  const canManageAssignments = canvasId
    ? (permissions?.canvas?.[canvasId]?.can_manage_assignments ?? false)
    : false;

  return { canEdit, canManageAssignments };
}
